import { useState } from 'react';
import { Link } from 'wouter';

export function CarrierForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await fetch('/api/carrier/auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: email.trim().toLowerCase() }),
            });
            setSubmitted(true);
        } catch (err: any) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md space-y-6">
                <div className="text-center space-y-2">
                    <span className="text-4xl filter drop-shadow-sm">🔑</span>
                    <h2 className="text-2xl font-bold tracking-tight text-slate-900">Forgot Password</h2>
                    <p className="text-sm text-slate-500">Enter your email and we'll send a reset link.</p>
                </div>

                <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-xl">
                    {submitted ? (
                        <div className="text-center space-y-4">
                            <div className="p-4 rounded-lg bg-green-50 border border-green-200 text-sm text-green-700">
                                If an account exists with that email, a reset link has been sent. Check your inbox.
                            </div>
                            <Link href="/carrier-login" className="font-medium text-primary hover:text-primary/80 text-sm transition-colors">
                                ← Back to Login
                            </Link>
                        </div>
                    ) : (
                        <>
                            {error && (
                                <div className="mb-6 p-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">{error}</div>
                            )}

                            <form onSubmit={handleSubmit} className="space-y-5">
                                <div className="space-y-1">
                                    <label className="text-sm font-medium text-slate-700">Email</label>
                                    <input
                                        type="email"
                                        className="w-full bg-white border border-slate-300 rounded-md px-3 py-2 text-slate-900 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="dispatch@yourcompany.com"
                                        required
                                        autoFocus
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="h-12 w-full bg-primary hover:bg-primary/90 text-white rounded-lg font-semibold transition disabled:opacity-60"
                                    disabled={loading}
                                >
                                    {loading ? 'Sending...' : 'Send Reset Link'}
                                </button>
                            </form>

                            <div className="mt-6 text-center text-sm">
                                <Link href="/carrier-login" className="font-medium text-primary hover:text-primary/80 transition-colors">
                                    ← Back to Login
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
